'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var sa = _interopDefault(require('sa-sdk-javascript'));

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var saInstance = null;

// 自动加 appname 前缀
var addPrefix = function addPrefix(attrs, APPNAME) {
  var result = {};
  for (var i in attrs) {
    result[APPNAME + "_" + i] = attrs[i];
  }
  return result;
};

// 添加 action_time
var addActionTime = function addActionTime(attrs) {
  var res = JSON.parse(JSON.stringify(attrs));
  res["action_time"] = Date.now();
  return res;
};

var SALogger = function SALogger(options) {
  classCallCheck(this, SALogger);

  _initialiseProps.call(this);

  var _options$needReport = options.needReport,
      needReport = _options$needReport === undefined ? true : _options$needReport,
      _options$autoTrack = options.autoTrack,
      autoTrack = _options$autoTrack === undefined ? false : _options$autoTrack,
      server_url = options.server_url,
      _options$show_log = options.show_log,
      show_log = _options$show_log === undefined ? true : _options$show_log,
      _options$debug_mode = options.debug_mode,
      debug_mode = _options$debug_mode === undefined ? false : _options$debug_mode,
      prefix = options.prefix,
      app_name = options.app_name,
      self_uid = options.self_uid,
      country_id = options.country_id,
      country_name = options.country_name;


  this.needReport = needReport;
  this.autoTrack = autoTrack;
  this.server_url = server_url;
  this.show_log = show_log;
  this.debug_mode = debug_mode;

  this.prefix = prefix;
  this.commonAttr = {
    app_name: app_name,
    self_uid: self_uid,
    country_id: country_id,
    country_name: country_name
  };

  this.init(self_uid);
}

//获取实例方法


// 修改公共属性


// 校验公共属性


// 默认情况下 JavaScript SDK 会自动生成一个 distinct_id 并永久保存在浏览器中的 Cookie 中
// 调用 login() 传入的 userId 会替换 Cookie 中的 distinct_id


// 在你用过 sa.login 后，在一个浏览器有多个用户登录的时候，你想在用户退出后改变当前的 distinct_id


// 自定义事件


// WebViewScreen


// WebInput


// WebClick
;

SALogger.getInstance = function (opts) {
  if (!saInstance) {
    saInstance = new SALogger(opts);
  }

  return saInstance;
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.init = function (userId) {
    if (_this.needReport) {
      sa.init({
        server_url: _this.server_url,
        heatmap_url: "https://static.sensorsdata.cn/sdk/1.10.9/heatmap.min.js",
        heatmap: {
          // 关闭自动上报click事件
          clickmap: "not_collect",
          // 关闭自动上报WebStay事件
          scroll_notice_map: "not_collect"
        },
        // 开启spa模式，自动上报pageview事件
        // is_track_single_page: true,
        // 开启console调试
        show_log: _this.show_log,
        use_app_track: true,
        // debug模式
        debug_mode: _this.debug_mode
      });

      _this.login(userId);
    } else {
      // eslint-disable-next-line
      console.warn("非 sa 上报环境，暂停上报");
    }
  };

  this.changeCommonAttr = function (attrs) {
    if (!_this.checkCommonAttr(attrs)) return;

    var formatAttrs = {};

    for (var key in attrs) {
      formatAttrs[key] = attrs[key].toString();
    }

    var app_name = formatAttrs.app_name,
        attr = objectWithoutProperties(formatAttrs, ["app_name"]);

    // 公共属性，只会在自定义事件中生效，在autoTrack之前调用，会自动添加到内置事件中

    sa.registerPage(_extends({
      app_name: app_name
    }, addPrefix(attr, _this.prefix)));
    // 自动上报 '$' 开头的默认事件
    if (_this.autoTrack) {
      sa.quick("autoTrack");
    }
  };

  this.checkCommonAttr = function (attr) {
    var need2check = ["app_name", "self_uid", "country_id", "country_name"];
    var checkList = need2check.reduce(function (resList, key) {
      var result = !!attr[key];
      return resList.concat(result);
    }, []);

    return checkList.every(function (e, i) {
      if (!e) {
        // eslint-disable-next-line
        console.warn("\u8BF7\u6DFB\u52A0 " + need2check[i] + " \u5C5E\u6027");
      }
      return e;
    });
  };

  this.login = function (userId) {
    if (userId && userId !== "-1") {
      sa.login(userId);
    }
    _this.changeCommonAttr(_extends({}, _this.commonAttr, { self_uid: userId }));
  };

  this.logout = function (refreshDistinctId) {
    sa.logout(refreshDistinctId);
  };

  this.track = function (event, properties) {
    if (_this.needReport) {
      sa.track(event, properties);
    } else {
      // eslint-disable-next-line
      console.warn("非 sa 上报环境，暂停上报");
    }
  };

  this.hasPrefixTrack = function (event, properties) {
    _this.track(_this.prefix + "_" + event, _extends({}, addPrefix(addActionTime(properties), _this.prefix)));
  };

  this.view = function (properties) {
    if (!properties["page_view_type"]) {
      // eslint-disable-next-line
      console.warn("请添加关键属性 page_view_type，值为 Enter / Leave");
      return;
    }
    _this.hasPrefixTrack("WebViewScreen", properties);
  };

  this.input = function (properties) {
    _this.hasPrefixTrack("WebInput", properties);
  };

  this.click = function (properties) {
    _this.hasPrefixTrack("WebClick", properties);
  };
};

module.exports = SALogger;
